import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import * as AttachmentsActions from '../actions/AttachmentsActions';
import {DocumentTypes} from '../types/types';
import AttachmentCreateVersionConfirmationView from '../components/views/AttachmentCreateVersionConfirmationView';
import {CreateNewVersionConfirmationDispatchProps, CreateNewVersionConfirmationStateProps} from '../types/containers';

const mapStateToProps = (state: State, ownProps): CreateNewVersionConfirmationStateProps => {
    const data = ownProps.data || null;
    const documentType: DocumentTypes = !!data ? data.documentType : null;
    return {
        documentType,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): CreateNewVersionConfirmationDispatchProps => {
    return {
        onPressConfirm: () => {
            dispatch(AttachmentsActions.CREATE_NEW_VERSION_ACTION.action());
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action(false));
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action(false));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const CreateVersionConfirmationContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(AttachmentCreateVersionConfirmationView);

export default CreateVersionConfirmationContainer;